// extracted by mini-css-extract-plugin
export var cardHeader = "_gm-1";
export var contentCard = "_gm-0";
export var headerActions = "_gm-3";
export var reorderHandle = "_gm-5";
export var titleArea = "_gm-2";
export var titleAreaWithHandle = "_gm-4";